const regexMap = {
  ALL_CHARS: /\w\S*/g,
  ALPHA_AND_DASHES_ONLY: /^[-\sa-z]+$/i,
  ALPHA_ONLY: /^[a-z]+$/i,
  ALPHANUMERIC_AND_DASHES: /^[a-z0-9\-\s]+$/i,
  ALPHANUMERIC_ONLY: /^[a-z0-9]+$/i,
  ALPHANUMERIC_SPACE: /^[a-z0-9\s]+$/i,
  ALPHANUMERIC_BOTH: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/,
  AT_LEAST_ONE_UPPERCASE: /^(?=.*[A-Z])/,
  CARRIAGE_RETURN: /\r/g,
  DASH_ON_END: /-+$/,
  DASH_ON_START: /^-+/,
  DOUBLE_DASH: /\-\-+/g,
  GEOLOCATION_HEADER: /Country=(\w+);City=(\w+);State=(\w*)/,
  GET_CARRIER_CODE: /([a-zA-Z]{1,2})?/g,
  GET_NUMERAL_SEQUENCE: /(\d+)/g,
  HEX_COLOR_CODE: /^#[a-f0-9]{6}$/i,
  IS_ABSOLUTE_URL: /^https?:\/\/|^\/\//i, // http://stackoverflow.com/a/10687158
  IS_COMBINATION_LETTERS_NUMBERS: /^(?=.*[a-zA-Z])(?=.*[0-9])/,
  IS_COMMA_SEPARATED_EMAIL: /^\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\s*(,\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4})*\s*$/i,
  IS_DATE_FORMAT: /^\d{2}([-])\d{2}\1\d{4}$/i, // matches format 'MM-DD-YYYY'
  IS_DATE_FORMAT_YEAR_FIRST: /^\d{4}([-])\d{2}\1\d{2}$/i, // matches format 'YYYY-MM-DD'
  IS_EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  IS_HTML: /<(br|hr|input|source|frame|!DOCTYPE).*?>|<(a|body|div|footer|head|header|h1|h2|h3|h4|h5|h6|html|i|iframe|script|section|select|span|strong|style|table|tbody|td|textarea|tfoot|th|thead|time|title|).*?<\/\2>/i,
  IS_NAME_SABRE: /^[A-Za-z\s][A-Za-z\-\s\']*$/, // Sabre-provided validation for name fields
  IS_US_ZIP_CODE: /^\d{5}$/,
  IS_VIRGIN_ATLANTIC_NUMBER: /^(?!0{10}$)[0-9]{10}$/,
  MARKDOWN_LIST: /(^\*+\s.+$)/gm,
  MARKDOWN_URL: /\[([^\[]+)\]\(([^\)]+)\)/g,
  MARKDOWN_BOLD: /\*\*([^\[]+)\*\*/g,
  MARKDOWN_ITALIC: /\*([^\[]+)\*/g,
  MEXICO: /(M)(e|é)(xico)/g,
  NEW_LINES: /(\n|\r)/g,
  NON_ALPHA_CHARS: /[^a-z]+/gi,
  NON_ALPHA_LATIN_CHARACTERS: /[ÀÁÂÃÄÅĀĂĄÇĆĈĊČÐĎĐÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĬĨĮĪİĴĶĹĻĽĿŁÑŃŅŇŊÒÓÔÕÖØŌŎŐÙÚÛÜÝŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽàáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵĺļľŀłkðòóôõöøōŏőñńņňŋŕŗřśŝşšţťŧùúûüũūŭůűųŵýŷżźž]/g,
  NON_ALPHANUMERIC_CHARS: /[^\w]/gi,
  NON_NUMERALS: /\D/g,
  NON_WORD: /[^\w\-]+/g,
  NUMERALS_ONLY: /^\d+$/g,
  NUMERIC_ONLY: /^[0-9]+$/i,
  PARENTHESES: /[()]/g,
  PASSWORD_CLUBPREMIER: /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,25}$/,
  PASSWORD_CLUBPREMIER_NOTSPECIALCHARACTER: /([´!`¨\]/·\[/≤+÷(/\/)(\-/)(\_/)(())(@#$%^~&*(,.;?¿¡"'=):{}(|<>|ñÑ])/g,
  SPACES_ONLY: /\s+/g,
  SQUARE_BRACKETS: /[[\]]/g,
  YOUTUBE_EMBED_URL: /((http|https):\/\/)?(www\.)?(youtube\.com\/embed\/)([a-zA-Z0-9\-\.]+)\/?/,
  YOUTUBE_URL: /((http|https):\/\/)?(www\.)?(youtube\.com)(\/)?([a-zA-Z0-9\-\.]+)\/?/,
  URL_HAS_STOREFRONT_AND_LANGUAGE: /[a-z]{2}-[a-z]{2}/,
  URL_LINK_TO_CMS_FILE: /sites\/default\/files/,
  ZERO_FFN_CHECK: /^0+$/,
};

export default regexMap;
